<!--attr.id="{{panel.id}}_widget"-->
<!-- for testversion2 id is not on the lm-dashboard-panel-list -->
<div soho-widget
    [class.has-pager]="showPagerInDashboard"
    widgetHeight="{{panel.widgetHeight}}"
    widgetWidth="{{panel.widgetWidth}}"
    attr.id="{{panel.id + '_widget'}}"
    attr.data-automation-id="lm-{{panel.automationId}}-widget"
>
 
  <div soho-widget-header>
    <h2 soho-widget-title
        tabIndex="0"
        [ngClass]="{'hasOverviewClass': (hasOverviewNavigation && displayLinkAsText) }"
        soho-tooltip [content]="panel.title"
        attr.id="{{panel.id}}_widget_title"
        attr.data-automation-id="lm-{{panel.automationId}}-widget-title"
    >{{panel.title}}</h2>

    <div class="panelNavigation">
      <button *ngIf="hasOverviewNavigation && !displayLinkAsText"
          soho-button="icon"
          icon="right-arrow"
          soho-tooltip [content]="overNavigationLink"
          (click)="onNavigationClick()"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      ></button>
      <a *ngIf="hasOverviewNavigation && displayLinkAsText"
          soho-hyperlink
           attr.aria-label="{{panel.title}} - {{overNavigationLink}}"
          [attr.tabindex]="isInAccessibilityMode ? 0 : null"
          class="lm-hyperlink"
          (click)="onNavigationClick()"
          (keydown.enter)="onNavigationClick()"
          soho-tooltip [content]="overNavigationLink"
          attr.id="{{panel.id}}_overview_navigation"
          attr.data-automation-id="lm-{{panel.automationId}}-overview-navigation"
      >{{overNavigationLink}}</a>
      <button *ngIf="showCreateAction"
          soho-button="icon"
          icon="plusminus-folder-closed"
          soho-tooltip [content]="createActionLabel"
          (click)="onCreateClicked()"
          attr.id="{{panel.id}}_create_button"
          attr.data-automation-id="lm-{{panel.automationId}}-create-button"
      >{{createActionLabel}}</button>
    </div>
  </div>
 
  <div soho-widget-content [ngStyle]="{'overflow': 'hidden'}" class="{{contentClasses}}">
      <lm-list #LMListComponent
          [listUrlInfo]="listUrlInfo"
          [listSpec]="panel.listSpec"
          [fromDataView]="fromDataView"
          (listDisplayed)="onListDisplayed()"
          (contentModified)="onContentModified($event)"
          (sendContextMessageEvent)="onSendContextMessageEvent($event)"
          (listTransactionEvent)="onPanelTransactionEvent($event)"
      ></lm-list>
  </div>
</div>
